import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
  }

  toggle(event) {
    event.preventDefault()
    
    if (this.menuTarget.classList.contains("hidden")) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.menuTarget.classList.remove("hidden")
  }

  hide() {
    this.menuTarget.classList.add("hidden")
  }

  // Hide dropdown when clicking outside
  hideOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  // Connect the outside click listener
  menuTargetConnected() {
    document.addEventListener("click", this.hideOnClickOutside.bind(this))
  }

  // Disconnect the outside click listener
  menuTargetDisconnected() {
    document.removeEventListener("click", this.hideOnClickOutside.bind(this))
  }
}
